import axios from "axios";
import { getAdminAuth, setAdminAuth, clearAdminAuth } from "./adminAuth";

export const ADMIN_SESSION_EXPIRED_EVENT = "admin-session-expired";

const adminAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

adminAxios.interceptors.request.use((config) => {
  const auth = getAdminAuth();
  if (auth?.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`;
  }
  return config;
});

let refreshPromise = null;

function refreshAdminSession() {
  const auth = getAdminAuth();
  if (!auth?.refreshToken) {
    return Promise.reject(new Error("No refresh token"));
  }

  if (!refreshPromise) {
    refreshPromise = axios
      .post(process.env.REACT_APP_BASE_URL + "auth/refresh", {
        refresh_token: auth.refreshToken,
      })
      .then((res) => {
        const data = res.data.data;
        setAdminAuth({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          admin: auth.admin,
        });
        return data.accessToken;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

adminAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const accessToken = await refreshAdminSession();
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return adminAxios(originalRequest);
      } catch {
        clearAdminAuth();
        window.dispatchEvent(new Event(ADMIN_SESSION_EXPIRED_EVENT));
      }
    }

    return Promise.reject(error);
  }
);

export default adminAxios;
